// eslint-disable-next-line no-unused-vars
var ArrayHelper = {
  created: function() {},
  methods: {
    asyncForEach: async function(array, callback) {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array);
      }
    }
  }
};
